import { render, staticRenderFns } from "./CalculationOrder.vue?vue&type=template&id=08680f28&"
import script from "./CalculationOrder.vue?vue&type=script&lang=js&"
export * from "./CalculationOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports